import styled from '@emotion/styled'
import { Typography, TypographyProps } from '@mui/material'
import React from 'react'

export const Caption = styled((props: TypographyProps) => (
  <Typography {...props} variant='caption' />
))`
  color: ${({ theme }) => theme.palette.stone[500]};
`
